export default __webpack_public_path__ + "50d17268194c4b16eba916b95603ca7d.png";